export const CHECKOUT_URL =
  'https://balonmanopro360.impultienda.ar/checkout?utm_source=facebook&utm_medium=paid&utm_campaign={{campaign.name}}&utm_term={{adset.name}}&utm_content={{ad.name}}&utm_id={{ad.id}}';
